import {NgModule, ModuleWithProviders} from '@angular/core'
import {SearchInfoPipe} from './pipes/searchInfo.pipe'
import {SearchInfoCSPipe} from './pipes/searchInfoCS.pipe'
import {SearchTextPipe} from './pipes/searchText.pipe'
import {FilterToolPipe} from './pipes/filterTool.pipe'
import {FilterGroupPipe} from './pipes/filterGroup.pipe'
import {NoSanitizePipe} from './pipes/noSanitize.pipe'
import {DefaultImgPipe} from './pipes/defaultImage.pipe'
import {SanitizeHtmlPipe} from './pipes/sanitize.pipe'
import {SearchObjectPipe} from './pipes/searchObject.pipe'

@NgModule({
    imports: [],
    declarations: [
        DefaultImgPipe,
        SearchInfoPipe,
        SearchInfoCSPipe,
        SearchObjectPipe,
        SearchTextPipe,
        FilterGroupPipe,
        FilterToolPipe,
        NoSanitizePipe,
        SanitizeHtmlPipe
    ],
    exports: [
        DefaultImgPipe,
        SearchInfoPipe,
        SearchInfoCSPipe,
        SearchObjectPipe,
        SearchTextPipe,
        FilterGroupPipe,
        FilterToolPipe,
        NoSanitizePipe,
        SanitizeHtmlPipe
    ]
})
export class FwkPipesModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: FwkPipesModule,
            providers: []
        };
    }

    constructor () {
        console.log('FwkPipesModule constructor')
    }
}
